export const NO_ALARM = 'NoAlarm';
export const B2B_ALARM = 'B2BAlarm';
export const LOC_ALARM = 'LocAlarm';

const mutuallyExclusiveOptions = (feature: string): string[] => {
  switch (feature) {
    case B2B_ALARM:
      return [LOC_ALARM, NO_ALARM];
    case LOC_ALARM:
      return [B2B_ALARM, NO_ALARM];
    default:
      return [NO_ALARM];
  }
};

export const selectedSecurityFeaturesCopy = (
  features: string[],
  newFeature: string
): string[] => {
  if (newFeature === NO_ALARM) {
    return features.includes(NO_ALARM) ? [] : [NO_ALARM];
  }

  const copyFeatures = [...features];

  const foundIndex = copyFeatures.findIndex((item) => item === newFeature);
  if (foundIndex > -1) {
    copyFeatures.splice(foundIndex, 1);
  } else {
    copyFeatures.push(newFeature);
  }

  return copyFeatures.filter(
    (item) => !mutuallyExclusiveOptions(newFeature).includes(item)
  );
};
